import React from 'react';
import { useLocation } from '@reach/router';

import { routes } from '@config/routes';
import { useNavigate } from '@lib/routing';
import { createLocationSearchFromState } from '@modules/shared/helpers';
import { PageStyled } from '@modules/layout/styled';
import { useBaseLayout } from '@modules/layout/templates';
import { StudentTabs } from '@modules/students/organisms';

type StudentsSingleEntryProps = {
    backRouteUrl: string;
    editRouteUrl: string;
    backRouteHash?: string;
};

const StudentsSingleEntry = (props: StudentsSingleEntryProps): React.ReactElement => {
    const { backRouteUrl, editRouteUrl, backRouteHash = '' } = props;

    const location = useLocation();
    const navigate = useNavigate();

    const { setRedirect } = useBaseLayout();

    React.useEffect(() => {
        const backLinkState = { ...(location.state as Record<string, any>) };
        const backPath = backLinkState?.backPath;

        if (backPath) delete backLinkState.backPath;

        const backLink =
            createLocationSearchFromState({
                pathname: backPath ?? backRouteUrl ?? routes.students.path,
                state: backLinkState,
            }) + backRouteHash;

        const handleRedirect = (): void => {
            navigate(backLink, { state: backLinkState });
        };

        setRedirect(() => handleRedirect);
    }, []);

    return (
        <PageStyled.Root>
            <StudentTabs editRouteUrl={editRouteUrl} />
        </PageStyled.Root>
    );
};

export { StudentsSingleEntry };
